@if (canShowPdfExport) {
  <div class="z-500 position-absolute top-2 right-4">
    <div class="radius-md bg-primary-darker text-white padding-105 font-ui-xs" id="DownloadLinks">
      Export results as:
      <a
        aria-label="clickable link PDF"
        id="PDFLink"
        class="badge-pdf usa-link--inverse cursor-pointer radius-md padding-05"
        (click)="onPdf()"
        (keypress)="onPDFKeyPress($event)"
        >PDF</a
      >&nbsp;
      <a
        aria-label="clickable link Excel"
        id="ExcelLink"
        class="badge-xlxs usa-link--inverse cursor-pointer radius-md padding-05"
        (click)="onExcel()"
        (keypress)="onExelKeyPress($event)"
        >XLSX</a
      >
    </div>
  </div>
}
